const base64UrlEncode = (str) =>
  btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const base64UrlDecode = (str) => {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  while (str.length % 4) str += "=";
  return atob(str);
};

export const encodeResourceParams = (paramsObj) => {
  try {
    const keyValuePairs = Object.entries(paramsObj).map(
      ([key, value]) => `${key}=${value}`
    );
    const paramString = keyValuePairs.join("|");
    return base64UrlEncode(paramString);
  } catch (error) {
    console.error("Encoding failed:", error);
    return null;
  }
};

export const decodeResourceParams = (data) => {
  if (!data) return null;
  try {
    const decoded = base64UrlDecode(data);
    const keyValuePairs = decoded.split("|");
    const paramsObj = {};

    keyValuePairs.forEach((pair) => {
      const [key, value] = pair.split("=");
      paramsObj[key] = value || null;
    });

    return paramsObj;
  } catch (error) {
    console.error("Decoding failed:", error);
    return null;
  }
};
